/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.server.getConfig'

export { $nsid }

/** Get details about ozone's server configuration. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    appview: l.optional(l.ref<ServiceConfig>((() => serviceConfig) as any)),
    pds: l.optional(l.ref<ServiceConfig>((() => serviceConfig) as any)),
    blobDivert: l.optional(l.ref<ServiceConfig>((() => serviceConfig) as any)),
    chat: l.optional(l.ref<ServiceConfig>((() => serviceConfig) as any)),
    viewer: l.optional(l.ref<ViewerConfig>((() => viewerConfig) as any)),
    verifierDid: l.optional(l.string({ format: 'did' })),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type ServiceConfig = {
  $type?: 'tools.ozone.server.getConfig#serviceConfig'
  url?: l.UriString
}

export type { ServiceConfig }

const serviceConfig = l.typedObject<ServiceConfig>(
  $nsid,
  'serviceConfig',
  l.object({ url: l.optional(l.string({ format: 'uri' })) }),
)

export { serviceConfig }

type ViewerConfig = {
  $type?: 'tools.ozone.server.getConfig#viewerConfig'
  role?:
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
}

export type { ViewerConfig }

const viewerConfig = l.typedObject<ViewerConfig>(
  $nsid,
  'viewerConfig',
  l.object({
    role: l.optional(
      l.string<{
        knownValues: [
          'tools.ozone.team.defs#roleAdmin',
          'tools.ozone.team.defs#roleModerator',
          'tools.ozone.team.defs#roleTriage',
          'tools.ozone.team.defs#roleVerifier',
        ]
      }>(),
    ),
  }),
)

export { viewerConfig }
